import { useEffect, useState, type FormEvent } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '@/features/auth/AuthProvider';
import { kuunda } from '@/lib/kuunda';
import { lockNativeSystemBarsStyle } from '@/lib/nativeApp';
import './admin-login.css';

/** Connexion staff — interface distincte de l’espace entrepreneur. */
export function AdminLoginPage() {
  const { signIn } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => lockNativeSystemBarsStyle('dark'), []);

  async function onSubmit(e: FormEvent) {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const session = await signIn(email.trim(), password);
      const uid = session.user.id;
      const { data } = await kuunda.from('profiles').select('role').eq('id', uid).maybeSingle();
      const role = data?.role;
      if (role !== 'admin' && role !== 'advisor' && role !== 'jury') {
        setError('Ce compte n’a pas accès à l’administration.');
        await kuunda.auth.signOut();
        return;
      }
      const target = location.pathname.startsWith('/admin') ? location.pathname : '/admin';
      navigate(target, { replace: true });
    } catch (err) {
      const raw = err instanceof Error ? err.message : 'Connexion impossible';
      if (/invalid login credentials/i.test(raw)) {
        setError('Email ou mot de passe incorrect.');
      } else {
        setError(raw);
      }
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="admin-login">
      <div className="admin-login-card">
        <div className="admin-login-brand">
          <img src="/logo-isbd.png" alt="ISBD" />
          <p className="admin-login-badge">Espace administration</p>
        </div>
        <h1>Pilotage plateforme</h1>
        <p className="admin-login-lead">Accès réservé aux comptes administrateur, advisor et jury.</p>
        <form className="admin-login-form" onSubmit={onSubmit}>
          {error ? <div className="error-banner">{error}</div> : null}
          <div className="field">
            <label htmlFor="admin-email">Email</label>
            <input
              id="admin-email"
              type="email"
              autoComplete="username"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
          </div>
          <div className="field">
            <label htmlFor="admin-password">Mot de passe</label>
            <input
              id="admin-password"
              type="password"
              autoComplete="current-password"
              required
              minLength={10}
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </div>
          <button className="btn btn-primary btn-block" type="submit" disabled={loading}>
            {loading ? 'Connexion…' : 'Accéder au dashboard'}
          </button>
        </form>
        <p className="admin-login-foot">
          <Link to="/">Retour au site</Link>
          {' · '}
          <Link to="/connexion">Connexion entrepreneur</Link>
        </p>
      </div>
    </div>
  );
}
